import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// functions
export function assertEqual(val) {
  return val;
}
export function assertNotEqual(val) {
  return val;
}
export function assertIs(_arg) {}
export function assertNever(_x) {
  throw new Error();
}
export function assert(_) {}
export function getEnumValues(entries) {
  const numericValues = Object.values(entries).filter(v => typeof v === "number");
  const values = Object.entries(entries).filter(_ref => {
    let [k, _] = _ref;
    return numericValues.indexOf(+k) === -1;
  }).map(_ref2 => {
    let [_, v] = _ref2;
    return v;
  });
  return values;
}
export function joinValues(array) {
  let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "|";
  return array.map(val => stringifyPrimitive(val)).join(separator);
}
export function jsonStringifyReplacer(_, value) {
  if (typeof value === "bigint") return value.toString();
  return value;
}
export function cached(getter) {
  const set = false;
  return {
    get value() {
      if (!set) {
        const value = getter();
        Object.defineProperty(this, "value", {
          value
        });
        return value;
      }
      throw new Error("cached value already set");
    }
  };
}
export function nullish(input) {
  return input === null || input === undefined;
}
export function cleanRegex(source) {
  const start = source.startsWith("^") ? 1 : 0;
  const end = source.endsWith("$") ? source.length - 1 : source.length;
  return source.slice(start, end);
}
export function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / 10 ** decCount;
}
export function defineLazy(object, key, getter) {
  const set = false;
  Object.defineProperty(object, key, {
    get() {
      if (!set) {
        const value = getter();
        object[key] = value;
        return value;
      }
      throw new Error("cached value already set");
    },
    set(v) {
      Object.defineProperty(object, key, {
        value: v
        // configurable: true,
      });
      // object[key] = v;
    },
    configurable: true
  });
}
export function assignProp(target, prop, value) {
  Object.defineProperty(target, prop, {
    value,
    writable: true,
    enumerable: true,
    configurable: true
  });
}
export function mergeDefs() {
  const mergedDescriptors = {};
  for (var _len = arguments.length, defs = new Array(_len), _key = 0; _key < _len; _key++) {
    defs[_key] = arguments[_key];
  }
  for (const def of defs) {
    const descriptors = Object.getOwnPropertyDescriptors(def);
    Object.assign(mergedDescriptors, descriptors);
  }
  return Object.defineProperties({}, mergedDescriptors);
}
export function cloneDef(schema) {
  return mergeDefs(schema._zod.def);
}
export function getElementAtPath(obj, path) {
  if (!path) return obj;
  return path.reduce((acc, key) => acc === null || acc === void 0 ? void 0 : acc[key], obj);
}
export function promiseAllObject(promisesObj) {
  const keys = Object.keys(promisesObj);
  const promises = keys.map(key => promisesObj[key]);
  return Promise.all(promises).then(results => {
    const resolvedObj = {};
    for (let i = 0; i < keys.length; i++) {
      resolvedObj[keys[i]] = results[i];
    }
    return resolvedObj;
  });
}
export function randomString() {
  let length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  const chars = "abcdefghijklmnopqrstuvwxyz";
  let str = "";
  for (let i = 0; i < length; i++) {
    str += chars[Math.floor(Math.random() * chars.length)];
  }
  return str;
}
export function esc(str) {
  return JSON.stringify(str);
}
export const captureStackTrace = "captureStackTrace" in Error ? Error.captureStackTrace : function () {};
export function isObject(data) {
  return typeof data === "object" && data !== null && !Array.isArray(data);
}
export const allowsEval = cached(() => {
  var _navigator;
  // @ts-ignore
  if (typeof navigator !== "undefined" && (_navigator = navigator) !== null && _navigator !== void 0 && (_navigator = _navigator.userAgent) !== null && _navigator !== void 0 && _navigator.includes("Cloudflare")) {
    return false;
  }
  try {
    const F = Function;
    new F("");
    return true;
  } catch (_) {
    return false;
  }
});
export function isPlainObject(o) {
  if (isObject(o) === false) return false;
  // modified constructor
  const ctor = o.constructor;
  if (ctor === undefined) return true;
  // modified prototype
  const prot = ctor.prototype;
  if (isObject(prot) === false) return false;
  // ctor doesn't have static `isPrototypeOf`
  if (Object.prototype.hasOwnProperty.call(prot, "isPrototypeOf") === false) {
    return false;
  }
  return true;
}
export function numKeys(data) {
  let keyCount = 0;
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      keyCount++;
    }
  }
  return keyCount;
}
export const getParsedType = data => {
  const t = typeof data;
  switch (t) {
    case "undefined":
      return "undefined";
    case "string":
      return "string";
    case "number":
      return Number.isNaN(data) ? "nan" : "number";
    case "boolean":
      return "boolean";
    case "function":
      return "function";
    case "bigint":
      return "bigint";
    case "symbol":
      return "symbol";
    case "object":
      if (Array.isArray(data)) {
        return "array";
      }
      if (data === null) {
        return "null";
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return "promise";
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return "map";
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return "set";
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return "date";
      }
      // @ts-ignore
      if (typeof File !== "undefined" && data instanceof File) {
        return "file";
      }
      return "object";
    default:
      throw new Error("Unknown data type: ".concat(t));
  }
};
export const propertyKeyTypes = new Set(["string", "number", "symbol"]);
export const primitiveTypes = new Set(["string", "number", "bigint", "boolean", "symbol", "undefined"]);
export function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
// zod-specific utils
export function clone(inst, def, params) {
  const cl = new inst._zod.constr(def !== null && def !== void 0 ? def : inst._zod.def);
  if (!def || params !== null && params !== void 0 && params.parent) cl._zod.parent = inst;
  return cl;
}
export function normalizeParams(_params) {
  const params = _params;
  if (!params) return {};
  if (typeof params === "string") return {
    error: () => params
  };
  if ((params === null || params === void 0 ? void 0 : params.message) !== undefined) {
    if ((params === null || params === void 0 ? void 0 : params.error) !== undefined) throw new Error("Cannot specify both `message` and `error` params");
    params.error = params.message;
  }
  delete params.message;
  if (typeof params.error === "string") return _objectSpread(_objectSpread({}, params), {}, {
    error: () => params.error
  });
  return params;
}
export function createTransparentProxy(getter) {
  let target;
  return new Proxy({}, {
    get(_, prop, receiver) {
      var _target;
      (_target = target) !== null && _target !== void 0 ? _target : target = getter();
      return Reflect.get(target, prop, receiver);
    },
    set(_, prop, value, receiver) {
      var _target2;
      (_target2 = target) !== null && _target2 !== void 0 ? _target2 : target = getter();
      return Reflect.set(target, prop, value, receiver);
    },
    has(_, prop) {
      var _target3;
      (_target3 = target) !== null && _target3 !== void 0 ? _target3 : target = getter();
      return Reflect.has(target, prop);
    },
    deleteProperty(_, prop) {
      var _target4;
      (_target4 = target) !== null && _target4 !== void 0 ? _target4 : target = getter();
      return Reflect.deleteProperty(target, prop);
    },
    ownKeys(_) {
      var _target5;
      (_target5 = target) !== null && _target5 !== void 0 ? _target5 : target = getter();
      return Reflect.ownKeys(target);
    },
    getOwnPropertyDescriptor(_, prop) {
      var _target6;
      (_target6 = target) !== null && _target6 !== void 0 ? _target6 : target = getter();
      return Reflect.getOwnPropertyDescriptor(target, prop);
    },
    defineProperty(_, prop, descriptor) {
      var _target7;
      (_target7 = target) !== null && _target7 !== void 0 ? _target7 : target = getter();
      return Reflect.defineProperty(target, prop, descriptor);
    }
  });
}
export function stringifyPrimitive(value) {
  if (typeof value === "bigint") return value.toString() + "n";
  if (typeof value === "string") return "\"".concat(value, "\"");
  return "".concat(value);
}
export function optionalKeys(shape) {
  return Object.keys(shape).filter(k => {
    return shape[k]._zod.optin === "optional" && shape[k]._zod.optout === "optional";
  });
}
export const NUMBER_FORMAT_RANGES = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-3.4028234663852886e38, 3.4028234663852886e38],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
export const BIGINT_FORMAT_RANGES = {
  int64: [/* @__PURE__*/BigInt("-9223372036854775808"), /* @__PURE__*/BigInt("9223372036854775807")],
  uint64: [/* @__PURE__*/BigInt(0), /* @__PURE__*/BigInt("18446744073709551615")]
};
export function pick(schema, mask) {
  const currDef = schema._zod.def;
  const def = mergeDefs(schema._zod.def, {
    get shape() {
      const newShape = {};
      for (const key in mask) {
        if (!(key in currDef.shape)) {
          throw new Error("Unrecognized key: \"".concat(key, "\""));
        }
        if (!mask[key]) continue;
        newShape[key] = currDef.shape[key];
      }
      assignProp(this, "shape", newShape); // self-caching
      return newShape;
    },
    checks: []
  });
  return clone(schema, def);
}
export function omit(schema, mask) {
  const currDef = schema._zod.def;
  const def = mergeDefs(schema._zod.def, {
    get shape() {
      const newShape = _objectSpread({}, schema._zod.def.shape);
      for (const key in mask) {
        if (!(key in currDef.shape)) {
          throw new Error("Unrecognized key: \"".concat(key, "\""));
        }
        if (!mask[key]) continue;
        delete newShape[key];
      }
      assignProp(this, "shape", newShape); // self-caching
      return newShape;
    },
    checks: []
  });
  return clone(schema, def);
}
export function extend(schema, shape) {
  if (!isPlainObject(shape)) {
    throw new Error("Invalid input to extend: expected a plain object");
  }
  const def = mergeDefs(schema._zod.def, {
    get shape() {
      const _shape = _objectSpread(_objectSpread({}, schema._zod.def.shape), shape);
      assignProp(this, "shape", _shape); // self-caching
      return _shape;
    },
    checks: []
  });
  return clone(schema, def);
}
export function merge(a, b) {
  const def = mergeDefs(a._zod.def, {
    get shape() {
      const _shape = _objectSpread(_objectSpread({}, a._zod.def.shape), b._zod.def.shape);
      assignProp(this, "shape", _shape); // self-caching
      return _shape;
    },
    get catchall() {
      return b._zod.def.catchall;
    },
    checks: [] // delete existing checks
  });
  return clone(a, def);
}
export function partial(Class, schema, mask) {
  const def = mergeDefs(schema._zod.def, {
    get shape() {
      const oldShape = schema._zod.def.shape;
      const shape = _objectSpread({}, oldShape);
      if (mask) {
        for (const key in mask) {
          if (!(key in oldShape)) {
            throw new Error("Unrecognized key: \"".concat(key, "\""));
          }
          if (!mask[key]) continue;
          // if (oldShape[key]!._zod.optin === "optional") continue;
          shape[key] = Class ? new Class({
            type: "optional",
            innerType: oldShape[key]
          }) : oldShape[key];
        }
      } else {
        for (const key in oldShape) {
          // if (oldShape[key]!._zod.optin === "optional") continue;
          shape[key] = Class ? new Class({
            type: "optional",
            innerType: oldShape[key]
          }) : oldShape[key];
        }
      }
      assignProp(this, "shape", shape); // self-caching
      return shape;
    },
    checks: []
  });
  return clone(schema, def);
}
export function required(Class, schema, mask) {
  const def = mergeDefs(schema._zod.def, {
    get shape() {
      const oldShape = schema._zod.def.shape;
      const shape = _objectSpread({}, oldShape);
      if (mask) {
        for (const key in mask) {
          if (!(key in shape)) {
            throw new Error("Unrecognized key: \"".concat(key, "\""));
          }
          if (!mask[key]) continue;
          // overwrite with non-optional
          shape[key] = new Class({
            type: "nonoptional",
            innerType: oldShape[key]
          });
        }
      } else {
        for (const key in oldShape) {
          // overwrite with non-optional
          shape[key] = new Class({
            type: "nonoptional",
            innerType: oldShape[key]
          });
        }
      }
      assignProp(this, "shape", shape); // self-caching
      return shape;
    },
    checks: []
  });
  return clone(schema, def);
}
export function aborted(x) {
  let startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  for (let i = startIndex; i < x.issues.length; i++) {
    var _x$issues$i;
    if (((_x$issues$i = x.issues[i]) === null || _x$issues$i === void 0 ? void 0 : _x$issues$i.continue) !== true) {
      return true;
    }
  }
  return false;
}
export function prefixIssues(path, issues) {
  return issues.map(iss => {
    var _a$path;
    var _a;
    (_a$path = (_a = iss).path) !== null && _a$path !== void 0 ? _a$path : _a.path = [];
    iss.path.unshift(path);
    return iss;
  });
}
export function unwrapMessage(message) {
  return typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
}
export function finalizeIssue(iss, ctx, config) {
  var _iss$path;
  const full = _objectSpread(_objectSpread({}, iss), {}, {
    path: (_iss$path = iss.path) !== null && _iss$path !== void 0 ? _iss$path : []
  });
  // for backwards compatibility
  if (!iss.message) {
    var _ref3, _ref4, _ref5, _unwrapMessage, _iss$inst, _iss$inst$error, _ctx$error, _config$customError, _config$localeError;
    const message = (_ref3 = (_ref4 = (_ref5 = (_unwrapMessage = unwrapMessage((_iss$inst = iss.inst) === null || _iss$inst === void 0 || (_iss$inst = _iss$inst._zod.def) === null || _iss$inst === void 0 || (_iss$inst$error = _iss$inst.error) === null || _iss$inst$error === void 0 ? void 0 : _iss$inst$error.call(_iss$inst, iss))) !== null && _unwrapMessage !== void 0 ? _unwrapMessage : unwrapMessage(ctx === null || ctx === void 0 || (_ctx$error = ctx.error) === null || _ctx$error === void 0 ? void 0 : _ctx$error.call(ctx, iss))) !== null && _ref5 !== void 0 ? _ref5 : unwrapMessage((_config$customError = config.customError) === null || _config$customError === void 0 ? void 0 : _config$customError.call(config, iss))) !== null && _ref4 !== void 0 ? _ref4 : unwrapMessage((_config$localeError = config.localeError) === null || _config$localeError === void 0 ? void 0 : _config$localeError.call(config, iss))) !== null && _ref3 !== void 0 ? _ref3 : "Invalid input";
    full.message = message;
  }
  // delete (full as any).def;
  delete full.inst;
  delete full.continue;
  if (!(ctx !== null && ctx !== void 0 && ctx.reportInput)) {
    delete full.input;
  }
  return full;
}
export function getSizableOrigin(input) {
  if (input instanceof Set) return "set";
  if (input instanceof Map) return "map";
  // @ts-ignore
  if (input instanceof File) return "file";
  return "unknown";
}
export function getLengthableOrigin(input) {
  if (Array.isArray(input)) return "array";
  if (typeof input === "string") return "string";
  return "unknown";
}
export function issue() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  const [iss, input, inst] = args;
  if (typeof iss === "string") {
    return {
      message: iss,
      code: "custom",
      input,
      inst
    };
  }
  return _objectSpread({}, iss);
}
export function cleanEnum(obj) {
  return Object.entries(obj).filter(_ref6 => {
    let [k, _] = _ref6;
    // return true if NaN, meaning it's not a number, thus a string key
    return Number.isNaN(Number.parseInt(k, 10));
  }).map(el => el[1]);
}
// instanceof
export class Class {
  constructor() {}
}